import React from 'react';
import Shortcommentcard from './ShortCommentCard';

const Qanda = () => {
    return (
        <div>
            <Shortcommentcard />
            <Shortcommentcard />
            <Shortcommentcard />
            <Shortcommentcard />
            <Shortcommentcard />
        </div>
    );
}

export default Qanda;
